import { Box, Typography, TextField, InputAdornment, Button } from "@mui/material";
import { useState, useCallback, useRef } from "react";
import InterventionTable from "./InterventionTable";
import InterventionFormDilogContainer from "./InterventionFormDilogContainer";
import SearchIcon from "@mui/icons-material/Search";
import AddIcon from "@mui/icons-material/Add";

const InterventionLabelContainer = () => {
  const [searchQuery, setSearchQuery] = useState<string>("");
  const tableRef = useRef<any>(null);

  const handleSearch = useCallback(() => {
    if (tableRef.current && tableRef.current.performSearch) {
      tableRef.current.performSearch(searchQuery);
    }
  }, [searchQuery]);

  const handleCreate = useCallback(() => {
    if (tableRef.current && tableRef.current.performCreate) {
      tableRef.current.performCreate();
    }
  }, []);

  return (
    <>
      <Box className='intervention-label-container'>
        <Box className='intervention-label-header'>
          <Box>
            <Typography variant="h4" className='intervention-label-title'>
              Intervention Label Management
            </Typography>
            <Typography variant="body1" className='intervention-label-subtitle'>
              Manage intervention labels and their order.
            </Typography>
          </Box>
          <Box className='intervention-label-header-actions'>
            <TextField
              className='intervention-search-input'
              placeholder="Search interventions..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              onKeyPress={(e) => {
                if (e.key === 'Enter') {
                  handleSearch();
                }
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
              sx={{ flex: 1, maxWidth: '300px' }}
            />
            <Button
              variant='contained'
              className='create-intervention-button'
              startIcon={<AddIcon />}
              onClick={handleCreate}
            >
              Create
            </Button>
          </Box>
        </Box>
        <InterventionTable ref={tableRef} />
      </Box>      
      <InterventionFormDilogContainer/>
    </>
  );
};

export default InterventionLabelContainer;
